<script setup>
import { ref, watch } from 'vue';
import { onUpdated } from 'vue';

const props = defineProps(['daySlots','selectedDay','selectedMonth', 'selectedYear', 'id' , 'name', 'isValid']);
defineEmits(['change']);
const daySlots = ref([]);

onUpdated(() => {
  if(daySlots.value.length > 0) {
    let elementToScrollId = 'wrapDays0';

    //Ciclo i giorni e mi fermo al primo giorno disponibile
    for (var i = 0; i < daySlots.value.length; i++) {
      if (daySlots.value[i]?.status === 'AVAILABLE') {
        elementToScrollId = 'wrapDays' + i;
        break;
      }
    }
    setTimeout(() => {
      scrollToItem(elementToScrollId);
    }, 250);
  }
});

// Calcola la posizione dell'elemento e scrolla il contenitore
function scrollToItem(itemId) {
  const container = document.getElementById('daysList');
  const targetElement = document.getElementById(itemId);
  container.scrollTop = targetElement.offsetTop;
}

watch(() => {
  daySlots.value = props.daySlots;
  // const currentDate = new Date();
  // currentDate.setHours(0, 0, 1);
  // daySlots.value = props.daySlots?.filter(daySlot => {
  //   const daySlotDate = new Date(daySlot.date);
  //   daySlotDate.setHours(23, 59, 59);
  //   return daySlotDate >= currentDate;
  // });
});

const isDateAvailable = (dateSlot) => {
  return dateSlot.status !== 'AVAILABLE';
}

function getStatusLabel(dateSlot) {
  switch (dateSlot.status) {
    case 'AVAILABLE':
      return 'Disponibile';
    case 'UNAVAILABLE':
      return 'Disponibilità terminata';
    case 'OFFLIMITS':
      switch (dateSlot.offlimitsSpecification) {
        case 'PRESENT':
          return 'Non é possibile prenotare per oggi';
        case 'FUTURE_POSSIBLE':
          return 'Non ancora disponibile';
        default:
          return 'Non disponibile';
      }
    case 'EARLY':
      return 'Non ancora disponibile';
    default:
      return '';
  }
}

function getMonthLabel(month, year) {
  const dt = new Date(year, month, 1);
  const m = dt.toLocaleString('default', { month: 'long' });
  const y = dt.toLocaleString('default', { year: 'numeric' });
  return m.charAt(0).toUpperCase() + m.slice(1) + ' ' + y;
}

</script>
<style scoped>
#daysList {
  position: relative;
}
@media screen and (min-width: 992px) {
  #daysList {
    height: 420px;
    overflow-y: auto;
  }
}
</style>
<template>

<div aria-live="polite" class="visually-hidden">
  <label for="daysList" tabindex="0">Elenco dei giorni prenotabili nel mese di {{ getMonthLabel(selectedMonth, selectedYear)  }}</label>
</div>

  <div :id="`${props.id}`">
  <div :class="`bg-white p-4 ${props.isValid ? '' : 'border border-danger'}`" id="daysList">
    <p v-if="!daySlots || daySlots?.length === 0" class="m-0">Nessun risultato</p>
    <div v-for="(day, index) in daySlots || []" :key="day.date" :id="`wrapDays${index}`" :class="`border-top mb-2 ${day.status !== 'AVAILABLE' ? 'mt-2' : ''}`">
      <div class="form-check">
        <input :name="`${props.name}`"
               :id="`${props.id}_${index}`"
               type="radio"
               :checked="props.selectedDay === day.date"
               :value="day.date"
               :disabled="isDateAvailable(day)"
               data-yup-label="Giorno"
               :data-yup-error-id-label="props.id"
               :data-yup-error-id-field="props.id"
               @change="() => { $emit('change', day.date); }">
        <label :for="`${props.id}_${index}`" :class="`${isDateAvailable(day) ? 'text-muted' : ''}`">
          <span class="text-capitalize">{{ (new Date(day.date)).toLocaleString('it-IT', { weekday: 'long', year: "numeric", month: "long", day: "numeric" }) }}</span>
          <br v-if="isDateAvailable(day)" />
          <small class="text-muted" v-if="isDateAvailable(day)">{{ getStatusLabel(day) }}</small>
        </label>
      </div>
    </div>
  </div>
</div>
</template>
